import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalytics } from './useAnalytics';

export const usePageTracking = () => {
  const location = useLocation();
  const { trackPageView } = useAnalytics();

  useEffect(() => {
    // Get the page title from the document
    const pageTitle = document.title || 'Untitled Page';
    
    // Track the page view
    trackPageView(location.pathname, pageTitle);
  }, [location, trackPageView]);
}; 